export function metersToMiles(meters) {
  return Number((meters * 0.000621371192).toFixed(0));
}

export function milesToMeters(miles) {
  return Number((miles * 1609.344).toFixed(0));
}



// WEBPACK FOOTER //
// ./src/utils/measure.js